import { useParams, useNavigate, useSearchParams, useLocation } from 'react-router-dom';
import { useDocumentVersion } from '@/hooks/useKnowledge';
import { VersionDiff } from '@/components/knowledge/VersionDiff';
import { Button } from '@/components/ui/button';
import { ArrowLeft } from 'lucide-react';
import { format } from 'date-fns';
import { ptBR } from 'date-fns/locale';

export function KnowledgeVersionComparePage() {
  const { id } = useParams<{ id: string }>();
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const location = useLocation();

  const handleBack = () => {
    if (location.key !== 'default') {
      navigate(-1);
    } else {
      navigate(`/knowledge/${id}/versions`);
    }
  };

  const v1Id = searchParams.get('v1');
  const v2Id = searchParams.get('v2');

  const { data: version1, isLoading: loading1 } = useDocumentVersion(id!, v1Id!);
  const { data: version2, isLoading: loading2 } = useDocumentVersion(id!, v2Id!);

  const isLoading = loading1 || loading2;

  if (isLoading) {
    return (
      <div className="container mx-auto px-4 py-6 sm:py-8">
        <div className="text-center py-12 text-muted-foreground">
          Carregando comparação...
        </div>
      </div>
    );
  }

  if (!version1 || !version2) {
    return (
      <div className="container mx-auto px-4 py-6 sm:py-8">
        <div className="text-center py-12 text-muted-foreground">
          Versões não encontradas. Certifique-se de selecionar duas versões válidas.
        </div>
      </div>
    );
  }

  return (
    <div className="container mx-auto px-4 py-6 sm:py-8 space-y-6">
      <div className="flex flex-col sm:flex-row items-start sm:items-center gap-4">
        <Button variant="ghost" onClick={handleBack} className="shrink-0">
          <ArrowLeft className="h-4 w-4 mr-2" />
          Voltar
        </Button>
        <div className="flex-1 min-w-0">
          <h1 className="text-2xl sm:text-3xl font-bold break-words">Comparar Versões</h1>
          <p className="text-xs sm:text-sm text-muted-foreground mt-1 break-words">
            v{version1.version} ({format(new Date(version1.createdAt), 'dd/MM/yyyy HH:mm', { locale: ptBR })})
            {' vs '}
            v{version2.version} ({format(new Date(version2.createdAt), 'dd/MM/yyyy HH:mm', { locale: ptBR })})
          </p>
        </div>
      </div>

      <VersionDiff version1={version1} version2={version2} />
    </div>
  );
}
